import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Card,
  CardContent,
  IconButton,
  Backdrop,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import ApiService from "../../services/api-service";
import notifier from "../../components/Notifier";
import SellPopup from "../SellPopup";
import AuctionPopup from "../AuctionPopup";
import BidPopup from "../BidPopup"; // For Buy Now actions
import BiddingPopup from "../BiddingPopup"; // For auctions
import ConfirmPopup from "../ConfirmPopup"; // Import the ConfirmPopup component
import SystemNotification from "../Stream/SystemNotification";



export default function ActiveListings({
  userId,
  streamData,
  role,
  onFeatureNFTChange = () => {},
  isOwner,
  onClose,
}) {
  const { t } = useTranslation("common");
  const [nftData, setNftData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const pageSize = 20;
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [openSellPopup, setOpenSellPopup] = useState(false);
  const [openAuctionPopup, setOpenAuctionPopup] = useState(false);
  const [openBuyPopup, setOpenBuyPopup] = useState(false);
  const [openBiddingPopup, setOpenBiddingPopup] = useState(false);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [saleStatus, setSaleStatus] = useState({});
  const [auctionHouse, setAuctionHouse] = useState({});
  const [openCancelDialog, setOpenCancelDialog] = useState(false); // Dialog state
  const [nftToCancel, setNftToCancel] = useState(null); // Track which NFT to cancel
  const [notifications, setNotifications] = useState([]);






  const targetUserId =
    role === "audience" ? streamData?.createdBy || streamData : userId;

    useEffect(() => {
      const savedFeaturedNFT = localStorage.getItem("featuredNFT");
      if (savedFeaturedNFT) {
        setSelectedNFT(JSON.parse(savedFeaturedNFT));
      }
      fetchUserNFTs();
      getAuctions();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchUserNFTs = useCallback(async (reset = false) => {
      if (loading || loaded) return;
      setLoading(true);
    
      if (reset) {
        setNftData([]);
        setPageNo(1);
        setSaleStatus({});
        setLoaded(false); // Reset loaded to allow new fetch
      }
    
      try {
        console.log("Using targetUserId:", targetUserId); // Debug log

        const response = await ApiService.USER_NFT_MUSIC({
          userId: targetUserId,  // Use the userId directly here
          pageSize,
          pageNo,
        });
    
        if (response?.result && Array.isArray(response.result)) {
          // Directly use response.result without filtering by owner ID
          const userNFTs = response.result;
          setNftData((prev) => (reset ? userNFTs : [...prev, ...userNFTs]));
          setLoaded(userNFTs.length < pageSize);
          if (!reset) setPageNo((prev) => prev + 1);
    
          const updatedSaleStatus = {};
    
          for (const nft of userNFTs) {
            const auctionInfo = auctionHouse[nft._id] || {};
            const activeBidResponse = await ApiService.ACTIVE_BID(nft._id);
            const activeBids = Array.isArray(activeBidResponse?.result)
              ? activeBidResponse.result.filter((bid) => bid.owner?._id === targetUserId)
              : [];
    console.log("auctionInfo:", auctionInfo);
            let isSale = nft.onSale;
            let isAuction = Boolean(auctionInfo.auctionId);
            console.log("auctionid:", auctionInfo.auctionId);
            let sellingPrice = nft.sellingPrice || 0;
            let highestBid = auctionInfo.highestBid || 0;
            let auctionId = auctionInfo.auctionId || null;
            let saleId = nft.saleId || null;
            let rank = nft.rank;
    
            activeBids.forEach((item) => {
              rank = item.rank || rank;
              if (item.onSale && !item.onAuction) {
                isSale = true;
                sellingPrice = item.sellingPrice || 0;
                saleId = item._id || null;
              } else if (item.onAuction) {
                isAuction = true;
                highestBid = item.highestBid || item.startingBid || 0;
                auctionId = item.auctionId || item._id || null;
              }
            });
    
            updatedSaleStatus[nft._id] = { isSale, isAuction, sellingPrice, highestBid, auctionId, saleId, rank };
          }
    
          setSaleStatus(updatedSaleStatus);
        } else {
          setLoaded(true);
        }
      } catch (error) {
        console.error("Failed to fetch NFTs:", error);
      } finally {
        setLoading(false);
      }
    }, [loading, loaded, auctionHouse, pageSize, pageNo, targetUserId]);
    
   
  // Fetch auction data once
  const getAuctions = useCallback(async () => {
    try {
      const response = await ApiService.BID_AND_AUCTIONS();
      setAuctionHouse(response?.result || {});
    } catch (error) {
      console.error("Failed to fetch auction data:", error);
    }
  }, []);

  


  const handleAuctionClick = useCallback((nft) => {
    const nftSaleStatus = saleStatus[nft._id] || {};
    setSelectedNFT({
      ...nft,
      isMaster: nft.owner === userId,
      nftId: nft._id,
      type: nft.type || "music",
      rank: nftSaleStatus.rank,
    });
    console.log("Selected NFT for auction:", nft);
    setOpenAuctionPopup(true);
  }, [saleStatus, userId]);

  const handleNewBidNotification = (message) => {
    setNotifications((prev) => [...prev, message]); // Add new bid notification
  };

  const handleSellClick = useCallback((nft) => {
    setSelectedNFT({ ...nft, isMaster: nft.owner === userId });
    setOpenSellPopup(true);

  }, [userId]);

  const handleAuctionClose = () => {
    setOpenAuctionPopup(false); // Close the auction popup
    onClose(); // Close Active Listings
  };

  const handlePlaceBidOpen = useCallback((nft) => {
    const nftSaleStatus = saleStatus[nft._id] || {};
    if (!nftSaleStatus.isAuction) {
      notifier.error("This NFT is not currently on auction.");
      return;
    }
    console.log("Selected NFT for bidding:", nft);
    setSelectedNFT({
      nftId: nft.fractionId,
      auctionId: nftSaleStatus.auctionId,
      highestBid: nftSaleStatus.highestBid || 0,
      isAuction: nftSaleStatus.isAuction,
      type: nft.type || "music",
      title: nft.title, // Add title here
      thumbnailImg: nft.thumbnailImg?.filePath || Images.default_user, // Add thumbnail image here
      artistData: nft.artistData || [], // Pass artist data

    });
    setOpenBiddingPopup(true);
  }, [saleStatus]);

  const handleBuyNowOpen = useCallback((nft) => {
    const nftSaleStatus = saleStatus[nft._id] || {};
    if (!nftSaleStatus.isSale) {
      notifier.error("Sale details not found for this NFT.");
      return;
    }
    setSelectedNFT({
      nftId: nft.fractionId,
      saleId: nft._id,
      sellingPrice: nftSaleStatus.sellingPrice || nft.sellingPrice || 0,
      type: nft.type || "music",
      fractionId: nft.fractionId,

    });
    setOpenBuyPopup(true);
    console.log("Selected NFT for Buy Now:", nft);
  }, [saleStatus]);

  const closeSellPopup = () => {
    setOpenSellPopup(false);
    setSelectedNFT(null);
    setOpenAuctionPopup(false);
    onClose(); // Close Active Listings

  };

  const handleCancelDialogOpen = (nft) => {
    setNftToCancel(nft);
    setOpenCancelDialog(true);

  };

  const handleCancelDialogClose = (confirmed) => {
    setOpenCancelDialog(false);
    if (confirmed) {
      confirmCancelSell();
    }
    setNftToCancel(null);
    onClose(); // Close Active Listings


  };

  const confirmCancelSell = async () => {
    if (!nftToCancel) return;
    try {
      setLoading(true);
      const nftSaleStatus = saleStatus[nftToCancel._id] || {};

      if (nftSaleStatus.isSale) {
        await ApiService.CANCEL_SELL_V2({
          nftId: nftSaleStatus.saleId,
          type: (nftToCancel.type || "music").toLowerCase(),
        });
      } else if (nftSaleStatus.isAuction) {
        await ApiService.CANCEL_AUCTION_NFT_V2({
          auctionId: nftSaleStatus.auctionId,
          type: (nftToCancel.type || "music").toLowerCase(),
        });
      } else {
        notifier.error("No active sale or auction found to cancel.");
        return;
      }

      notifier.success("Your sale has been canceled.");
      fetchUserNFTs(true); // Refresh the data after canceling
    } catch (error) {
      notifier.error(
        error.response?.data?.message || "Failed to cancel sale or auction."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCloseBiddingPopup = () => {
    console.log("BiddingPopup closed.");
    setOpenBiddingPopup(false); // Explicitly close the popup
  };

  return (
    <Box
      sx={{
        position: "relative",
        padding: "20px",
        backgroundColor: "#1A1A1A",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
            {/* Full-Screen Loader */}
            {loading && (
        <Backdrop open={loading} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Box
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          pointerEvents: "auto",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            color: "#FFF",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
            padding: "5px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Typography variant="h5" sx={{ color: "#FFF", mb: 3 }}>
        {t("Collection")}
      </Typography>

      {notifications.map((note, index) => (
        <SystemNotification key={index} notification={note} />
      ))}

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ color: "#A6A6A6", mb: 1 }}>
          {t("Active")}
        </Typography>
     {nftData
  .filter((nft) => nft.owner === targetUserId) // Filter by ownership
  .filter((nft) => {
    const status = saleStatus[nft._id] || {};
    return status.isSale || status.isAuction;
  })
  .map((nft, index) => {
    const nftSaleStatus = saleStatus[nft._id] || {};
    const { isSale, isAuction, sellingPrice, highestBid, rank } = nftSaleStatus;
    // Render NFT card



            return (
              <Card
                key={nft._id || index}
                sx={{ backgroundColor: "#2B2B2B", mb: 2 }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ color: "#FFF" }}>
                      {nft.title || t("noTitle")}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#FFEE20" }}>
                      {t("price")}: {isAuction ? `${highestBid} ${window?.__brandName || 'SIKI'} (Auction)` : isSale ? `${sellingPrice} ${window?.__brandName || 'SIKI'}` : "N/A"}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#A6A6A6" }}>
                      {t("rank")}: {rank}
                    </Typography>
                  </Box>
                  <Box>
                    {role === "audience" && (
                      <>
                        {isSale && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleBuyNowOpen(nft)}
                            sx={{
                              backgroundColor: "black",
                              color: "#FFF",
                              ml: 2,
                            }}
                          >
                            Buy
                          </Button>
                        )}
                        {isAuction && (
                          <Button
                            variant="outlined"
                            color="default"
                            onClick={() => handlePlaceBidOpen(nft)}
                            sx={{ color: "#FFF", ml: 2 }}
                          >
                            Place Bid
                          </Button>
                        )}
                      </>
                    )}
                    {role === "host" && (
                      <>
                        {(isSale || !isAuction) && (
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleCancelDialogOpen(nft)}
                            sx={{
                              color: "#FFF",
                              borderColor: "#3A3A3A",
                              ml: 2,
                            }}
                          >
                            Cancel Sale
                          </Button>
                        )}
                        {!isAuction && !isSale && (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleAuctionClick(nft)}
                            sx={{
                              color: "#FFF",
                              borderColor: "#3A3A3A",
                              ml: 2,
                            }}
                          >
                            Start Auction
                          </Button>
                        )}
                      </>
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}
      </Box>

      {role === "host" && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ color: "#A6A6A6", mb: 1 }}>
            {t("Not Listed")}
          </Typography>
          {nftData
            .filter(
              (nft) =>
                !saleStatus[nft._id]?.isSale &&
                !saleStatus[nft._id]?.isAuction
            )
            .map((nft, index) => (
              <Card
                key={nft._id || index}
                sx={{ backgroundColor: "#2B2B2B", mb: 2 }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ color: "#FFF" }}>
                      {nft.title || t("noTitle")}
                    </Typography>
                  </Box>
                  <Box>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleSellClick(nft)}
                      sx={{
                        color: "#FFF",
                        borderColor: "#3A3A3A",
                        ml: 2,
                      }}
                    >
                      Sell
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleAuctionClick(nft)}
                      sx={{
                        color: "#FFF",
                        borderColor: "#3A3A3A",
                        ml: 2,
                      }}
                    >
                      Start Auction
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            ))}
        </Box>
      )}

            {/* Confirmation Popup using ConfirmPopup */}
      <ConfirmPopup
        open={openCancelDialog}
        handleClose={handleCancelDialogClose}
        message="Are you sure you want to cancel this sale?"
        id={nftToCancel?._id}

      />

      {!loaded && (
        <Button
          onClick={() => fetchUserNFTs()}
          variant="contained"
          color="secondary"
          sx={{ mt: 2 }}
        >
          {loading ? <CircularProgress size={24} /> : t("loadMore")}
        </Button>
      )}

      {openSellPopup && selectedNFT && (
        <SellPopup
          open={openSellPopup}
          handleClose={closeSellPopup}
          nftCount={selectedNFT.nftCount}
          assetId={selectedNFT._id}
          type="music"
          nftId={selectedNFT.nftId}
          isMaster={selectedNFT.isMaster || false}
          rank={undefined} // Explicitly setting rank to undefined
          />
      )}

      {openAuctionPopup && selectedNFT && (
        <AuctionPopup
          open={openAuctionPopup}
          handleClose={handleAuctionClose} // Use the new function
          assetId={selectedNFT._id}
          type="music"
          isMaster={selectedNFT.isMaster || false}
          nftId={selectedNFT.nftId}
          rank={selectedNFT.rank}
          onNewBid={handleNewBidNotification}  // Pass down to AuctionPopup

        />
      )}

      {openBuyPopup && selectedNFT && (
        <BidPopup
          isBuy={true}
          open={openBuyPopup}
          handleClose={() => {
            setOpenBuyPopup(false);
            setSelectedNFT(null);
          }}
          sellingPrice={selectedNFT.sellingPrice}
          nftId={selectedNFT.fractionId}
          fractionId={selectedNFT.fractionId} // Explicitly pass fractionId
          assetId={selectedNFT._id}
          saleId={selectedNFT.saleId}
          rank={selectedNFT.rank}
          type={selectedNFT.type}
        />
      )}

          {openBiddingPopup && selectedNFT && (
            <>
              {console.log("Opening BiddingPopup with selectedNFT:", selectedNFT)}
              <BiddingPopup
                open={openBiddingPopup}
                handleClose={handleCloseBiddingPopup} // Use independent close handler

                isAuction={false}
                nft={selectedNFT}
                nftId={selectedNFT.fractionId}
                _id={selectedNFT._id}



              />
            </>
          )}



    </Box>
  );
}
